import React from "react"
import { FormattedMessage, injectIntl } from "react-intl"
import { isError, useQuery, useQueryClient } from "react-query"
import PaymentMethod from "../../../payment-account/model/paymentmethod"
import PaymentMethodService from "../../../payment-account/service/paymentMethodService"
import { usePaymentAccountSession } from "../../../payment-processing/usePaymentAccountSession"
import { HttpError } from "../../../state/helpers/Error"
import { SESSION_TYPE } from "../../../utils"
import RainforestPayment from "../../credit-card/rf-components/RainforestPayment"
import { RF_METHOD_TYPES } from "../../credit-card/rf-components/constants"
import LoadingSpinner from "../../spinner/loading.component"

type OwnProps = {
    contactId: string
    refreshContact: () => void
    locationId: string
}
const NewRainforestBankAccountWrapper = (props: OwnProps) => {

    const queryClient = useQueryClient()

    const { session, merchantID, isLoading: isLoadingSession } = usePaymentAccountSession(SESSION_TYPE.CREATE_PAYMENT_METHOD)

    const {data: paymentMethodData, isLoading: isLoadingData} = useQuery(["getPaymentMethodConfig"], () => {
        return PaymentMethodService.createPaymentMethodConfig(props.contactId, merchantID, "")
    }, {
        enabled: !isLoadingSession && !!merchantID
    })

    const handleApproved = async (event) => {
        const paymentMethodId = event.detail[0].data.payment_method_id
        const last4 = event.detail[0].data.ach.account_number_last_4
        await PaymentMethodService.addBankAccountOnFile({
            externalPaymentMethodId: paymentMethodId,
            last4: last4,
            contactId: props.contactId,
            locationId : props.locationId
        }).then(() => {
            setTimeout(() => {
                if (props.refreshContact) {
                    props.refreshContact()
                }
                queryClient.invalidateQueries("getPaymentMethodConfig", { exact: true })
            }, 500)
        })
    }

    const isPaymentMethod = (paymentMethod: PaymentMethod | HttpError | undefined)
        : paymentMethod is PaymentMethod => {
        return (
            paymentMethod != undefined && !isError(paymentMethod)
        )
    }
    if (!session || isLoadingData || isLoadingSession) {
        return <LoadingSpinner />
    }

    if (!isPaymentMethod(paymentMethodData)) {
        return <>
            <FormattedMessage
                id="customer.bank_account_on_file.not_supported"
                defaultMessage="The payment integration is not currently supported or hasn't been enabled" />
        </>
    }

    return (
        <>
            <RainforestPayment
                sessionKey={session.getSessionKey()}
                paymentMethodConfigID={paymentMethodData.getId()}
                allowedMethods="ACH"
                onSubmit={handleApproved}
                method={RF_METHOD_TYPES.SAVE_CARD}
            ></RainforestPayment>
        </>
    )

}


export default injectIntl(NewRainforestBankAccountWrapper)



// WEBPACK FOOTER //
// ./src/common/bank-account/rainforest/NewRainforestBankAccountWrapper.tsx